



























import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
@Component({
    components: {},
}) 
export default class dialogPanel extends Vue {
   
    public $refs!: {
       
    };

    @Prop({
        default:false
    })
    show:Boolean;
    @Prop({
        default:""
    })
    title:String;
    @Prop({
        default:"48.32vw"
    })
    width:String;
    @Prop({
        default:false
    })
    diyCancel:Boolean;

    async mounted() {
        
    }
    async created() {
    
    }

    closeFun(){
        this.$emit("closeFun");
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/dialogPanel.vue